//@ts-nocheck
import React from "react";
import CmsLayout from "../Pages/CMS_Layout/CmsLayout";

export default function AdminLayout({ user, isLoading }: { user?: any; isLoading?: boolean }) {
  // Acts as an adapter for CmsLayout which also relies on react-router-dom <Outlet />
  return <CmsLayout user={user} isLoading={isLoading} />;
}
